export default __webpack_public_path__ + "static/dot-bg-45c7374b83e2e1503f2cb0716464544f.png";